<template>

  <tr class="">
    <!-- avatar -->
    <!-- <td>
      <img v-if="!!user.avatar" :src="avatar" height="50px" :alt="user.username" />
      <img v-else :src="avatar" height="50px" alt="user_avatar" />
    </td> -->

    <!-- organization name -->
    <td>{{ user.organization_name }}</td>

    <!-- first name -->
    <td>{{ user.first_name }} {{ user.last_name }}</td>

    <!-- username -->
    <td>
      {{ user.user_name }}
      <!-- <router-link :to="'/users/' + user.slug + '/posts'">{{ user.user_name }}</router-link> -->
    </td>

    <!-- email -->
    <td>{{ user.email }}</td>

    <!-- role -->
    <td class="pr-0">
      <div  v-if="this.product == 1">
        <span id="role" v-if="user.role_id ==10" class="font-weight-bold" style="color: #598deff2">
          <span class="bullet">• </span>Customer </span>
        <span id="role" v-if="user.role_id == 6" class="font-weight-bold" style="color: #f19a16">
          <span class="bullet">• </span>Driver</span>
        <span id="role" v-if="user.role_id == 3" class="font-weight-bold" style="color: #a682b2">
          <span class="bullet">• </span>Manager</span>
        <span id="role" v-if="user.role_id == 9" class="font-weight-bold" style="color: #f27cf9e8">
          <span class="bullet">• </span>Production Supervisor</span>
        <span id="role" v-if="user.role_id == 4" class="font-weight-bold" style="color: #ef6880eb">
          <span class="bullet">• </span>Shipping & Receiving</span>
      <!-- <span
        id="role"
        v-if="user.role_id === '0'"
        class="rounded-pill px-3 py-1"
        style="
          background-color: #ebf7df;
          color: #66b34d;
          border: 1px solid #66b34d;
          text-align: center;
        "
      >
        Admin
      </span> -->
        <span id="role" v-if="user.role_id == 0" class="font-weight-bold" style="color: #66b34d">
          <span class="bullet">• </span>Admin</span>
        <span id="role" v-if="user.role_id == 1" class="font-weight-bold" style="color: #66b34d">
          <span class="bullet">• </span>Super Admin</span>
      </div>

      <div v-if="this.product == 1">
            <span class="font-weight-bold">
              <span class="bullet">• </span>{{ user.role_id }}
            </span>
      </div>

    </td>

    <!-- email notification status -->
    <td class="pl-4 pr-0">{{ user.send_update_email == 1 ? "Yes" : "No" }}</td>
    <!-- controls [assign role, ban|unban, delete] -->
    <td class="pr-0"> 
      <button type="button" v-if="user.deleted_at == null && (role == 0 || role == 1 || role == 4 || role == 10)" :title="
          this.$adminPannelUrl + '/redirect-login/' + userdata + '/' + UserOrgId
        " @click="LoginToUserAdminPanel(userdata, user.organization_id)"
        class="btn btn-sm btn-outline-primary text-primary mr-2">
        Login
      </button>

      <button type="button" v-if="user.send_update_email == 0 && (role == 0 || role == 1 || role == 4 || role == 6)"
        class="btn btn-sm btn-outline-success text-success mr-2" style="padding: 4px 16px" @click="assignRole('sub')">
        Subscribe
      </button>
      <button type="button" v-if="user.send_update_email != 0 && (role == 0 || role == 1 || role == 4 || role == 6)"
        class="btn btn-sm btn-outline-danger text-danger mr-2 unsub_btn" @click="assign('unsub')"
        v-show="user.send_update_email !== '0'">
        Unsubscribe
      </button>

      <button type="button" v-if="user.role_id == '1' && (role == 0 || role == 1 || role == 6)"
        class="btn btn-sm btn-outline-warning" @click="edit_user(user.master_user_id)">
        Edit
      </button>

      <!-- <button
                v-if="$gate.allow('assignRole', 'user') && user.role === 'banned'"
                type="button"
                class="btn btn-success"
                @click="assignRole('regular')"
        >Unban</button>
        <button
                v-if="$gate.allow('assignRole', 'user') && user.role !== 'banned'"
                type="button"
                class="btn btn-warning"
                @click="assign('banned')"
                v-show="user.role != 'admin'"
        >Ban</button>

        <button
                type="button"
                class="btn btn-default"
                v-show="user.role == 'admin'"
                disabled
        >Ban</button>

        <button
                v-if="$gate.allow('delete', 'user', user)"
                type="button"
                class="btn btn-danger"
                @click="deleteUser"
                v-show="user.role != 'admin'"
        >Delete</button>

        <button
                type="button"
                class="btn btn-danger"
                v-show="user.role == 'admin'"
                disabled
        >Delete</button> -->
    </td>
  </tr>
</template>

<script>
  import roleForm from "./role_form";

  export default {
    props: ["user","product","isLoader"],

    data: function () {
      return {
        userdata: "",
        UserOrgId: "",
        totalUsers: 0,
        UserId: "",
        AdminUserId: "",
        role: "",
        user_row_loader: true,
      };
    },
    computed: {
      avatar: function () {
        localStorage.setItem("total_users", JSON.stringify(this.user.length));
        let baseUrl = this.$baseURL + "/storage/users/";
        if (!!this.user.avatar) {
          return baseUrl + this.user.avatar;
        }
        return baseUrl + "avatar.svg";
      },
      showLoader: function (){
        console.log("computed loader",this.isLoader);
        this.user_row_loader = this.isLoader;
      },
      loaderStatus: function () {
        
        console.log("loader status",this.$store.getters['users/loader'])
        return this.$store.getters['users/loader'];
      },
    },
    watch:{
      showskLoader: function () {
        //  console.log("showskLoader table watch",this.setskeletonLoader);
          this.isLoader = this.setskeletonLoader;
          return this.setskeletonLoader;
      }
     } ,
    mounted: function () {
      
      this.role = localStorage.getItem("role");
      this.userdata = window.btoa(this.user.id);
      this.UserOrgId = window.btoa(this.user.organization_id);
      this.UserId = window.btoa(this.user.id);
      this.UserId = window.btoa(this.user.id);
      this.AdminUserId = localStorage.getItem("admin_id");

    },
    
    methods: {
      assignRoleForm() {
        this.$store.dispatch("modal/update", {
          action: "update",
          formData: this.user,
          title: "Assign Role to User " + this.user.user_name,
          component: roleForm,
        });
      },
      

      LoginToUserAdminPanel(user_id, org_id) {
        let login_user_id = window.btoa(this.user.id);
        let user_oorg_id = window.btoa(org_id);
        let admin_id = window.btoa(this.AdminUserId);
        // let user_role = JSON.parse(localStorage.getItem('role'));
        window.open(process.env.VUE_APP_LINENTECH_V3 + "/redirect-login/"+ login_user_id + "/" + user_oorg_id + "/" + admin_id, "_blank" );
        // window.open( process.env.VUE_APP_LINENTECH_V3+"/redirect-login/"+ login_user_id + "/" + user_oorg_id + "/" + admin_id + "/" + user_role, "_blank");
        // window.open( process.env.VUE_APP_LINENTECH_V3+"/redirect-login/"+ login_user_id + "/" + user_oorg_id, "_blank");
      },

      assign(role) {
        this.$store.dispatch("message/update", {
          title: this.user.user_name,
          body: "Are you sure you want to Unsubscribe this User?",
          class: "danger",
          confirm: true,
        });
        this.$bus.$off("proceed");
        this.$bus.$once("proceed", () => {
          this.assignRole(role);
          this.$store.dispatch("message/close");
        });
      },

      assignRole(role) {
        let user = this.user;
        

        // let loader = this.$loading.show({
        //   loader: 'dots',
        // });
        this.$emit("loaderStatus",true);
        this.$store.dispatch("users/assignRole", {
              user: user,
              role: role,
            })
            .then(() => {

                  
                 
              // loader.hide();
              this.$emit("loaderStatus",false);

                
                   

                  if(role == 'sub'){
                    this.$toast.success(`${user.user_name} User is Subscribed successfully`);
                  }
                  else if(role == 'unsub'){
                    this.$toast.success(`${user.user_name} User is Un-Subscribed successfully`);
                    window.location.reload();
                  }
                  
                    
              
                
            
              
              
            })
            .catch((error) => {
              let response = error.response;
              this.$toast.error(response.data.message);
          })   
      },

      deleteUser() {
        this.$store.dispatch("message/update", {
          title: this.user.user_name,
          body: "Are you sure you want to delete this User?",
          class: "danger",
          confirm: true,
        });

        this.$bus.$off("proceed");
        this.$bus.$once("proceed", () => {
          this.delete(this.user);
          this.$store.dispatch("message/close");
        });
      },

      delete(user) {
        this.$store
          .dispatch("users/deleteUser", user)
          .then((response) => {
            // send successful message
            this.$toast.success(response.data.message);
          })
          .catch((error) => {
            // send error message
            this.$toast.error(error.response.data.message);
          });
      },
      edit_user(user_id) {
        this.$parent.create_user(user_id);
      },
    },
  };
</script>
<style>
  td button:hover {
    color: white !important;
  }
</style>
<style scoped>
 table tr td:nth-child(1) {
    width: 17% !important;
  }
   table tr td:nth-child(2) {
    width: 13% !important;
  }
   table tr td:nth-child(3) {
    width: 13% !important;
  }
   table tr td:nth-child(4) {
    width: 17% !important;
  }
   table tr td:nth-child(5) {
    width: 13% !important;
  }
   table tr td:nth-child(6) {
    width: 10% !important;
  }
  table tr td:nth-child(7) {
    width: 27% !important;
  }
/* 
  table tr td:nth-child(1) {
    width: 17% !important;
  }

  table tr td:nth-child(2) {
    width: 17% !important;
  }

  table tr td:nth-child(3) {
    width: 14% !important;
  }

  table tr td:nth-child(4) {
    width: 17% !important;
  }

  table tr td:nth-child(5) {
    width: 13% !important;
  }

  table tr td:nth-child(6) {
    width: 10% !important;
  }

  table tr td:nth-child(7) {
    width: 12% !important;
  } */

  @media only screen and (min-width: 1280px) and (max-width: 1724px) {
    td button {
      font-size: 10px;
    }

    #role {
      font-size: 10px;
      word-wrap: break-word;
    }

    td {
      font-size: 12px;
    }

    .bullet {
      font-size: 15px;
      margin-top: 4px;
    }

    table tr td:nth-child(1) {
      width: 16% !important;
    }

    table tr td:nth-child(2) {
      width: 16% !important;
    }

    table tr td:nth-child(3) {
      width: 14% !important;
    }

    table tr td:nth-child(4) {
      width: 16% !important;
    }

    table tr td:nth-child(5) {
      width: 15% !important;
    }

    table tr td:nth-child(6) {
      width: 8% !important;
    }

    table tr td:nth-child(7) {
      width: 15% !important;
    }
  }
</style>